// import React, { useContext, useRef, useEffect, useState } from "react";
// import styles from "./HomeCommunityCarousel.module.css";
// import { HomePageContext } from "../../store/HomePageContext";
// import { Link } from "react-router-dom";
// import { FourElementsCarousel } from "../../utilities";
// import {
//   FaPlay,
//   FaPause,
//   FaExpand,
//   FaVolumeMute,
//   FaVolumeUp,
// } from "react-icons/fa";
// import social from "./social.webp";

// const HomeCommunityCarousel = ({ itemWidth, itemHeight, items }) => {
//   const { homeScreenDetails } = useContext(HomePageContext);
//   const maflamShowsData = homeScreenDetails?.maflamShowsData || [];
//   const maflamShowsDataTitle = homeScreenDetails?.maflamShowsTitle || [];
//   const [isPlaying, setIsPlaying] = useState({});
//   const [isMuted, setIsMuted] = useState({});
//   const [videoErrors, setVideoErrors] = useState({});

//   // Handle video play/pause
//   const handleVideoPlayPause = (videoId, video) => {
//     if (isPlaying[videoId]) {
//       video.pause();
//       setIsPlaying((prev) => ({ ...prev, [videoId]: false }));
//     } else {
//       video.play().catch((err) => {
//         console.error("Video playback failed:", err);
//         setVideoErrors((prev) => ({ ...prev, [videoId]: true }));
//       });
//       setIsPlaying((prev) => ({ ...prev, [videoId]: true }));
//     }
//   };

//   // Handle video error
//   const handleVideoError = (videoId) => {
//     setVideoErrors((prev) => ({ ...prev, [videoId]: true }));
//     setIsPlaying((prev) => ({ ...prev, [videoId]: false }));
//   };

//   return (
//     <div className={styles.parent}>
//       <div className={styles.carouselcontainer}>
//         <Link style={{ fontSize: "36px" }} to="R2/R4/socialmedia">
//           {maflamShowsDataTitle.title}
//         </Link>
//         <FourElementsCarousel
//           style={{ width: "100%", overflow: "hidden" }}
//           itemWidth={itemWidth}
//           itemHeight={itemHeight}
//           items={maflamShowsData.map((item) => ({
//             id: item.id,
//             content: (
//               <div className={styles.card}>
//                 <img
//                   src={item.logoUrl}
//                   alt={`Show logo`}
//                   className={styles.logo89}
//                   style={{ width: itemWidth, height: itemHeight }}
//                 />
//                 <div className={styles.videoContainer}>
//                   {videoErrors[item.id] ? (
//                     <img
//                       src={social}
//                       alt="Social Media Content"
//                       className={styles.fallbackImage}
//                       style={{ maxWidth: "320px" }}
//                     />
//                   ) : (
//                     <>
//                       <video
//                         src={item.videoUrl}
//                         className={styles.img89}
//                         muted={isMuted[item.id]}
//                         loop
//                         playsInline
//                         poster={item.thumbNailUrl || social}
//                         style={{ maxWidth: "320px" }}
//                         onPlay={() =>
//                           setIsPlaying((prev) => ({ ...prev, [item.id]: true }))
//                         }
//                         onPause={() =>
//                           setIsPlaying((prev) => ({
//                             ...prev,
//                             [item.id]: false,
//                           }))
//                         }
//                         onError={() => handleVideoError(item.id)}
//                       >
//                         Your browser does not support the video tag.
//                       </video>
//                       <div className={styles.videoControls}>
//                         <button
//                           className={styles.playButton}
//                           onClick={(e) => {
//                             const video =
//                               e.currentTarget.parentElement.parentElement.querySelector(
//                                 "video"
//                               );
//                             handleVideoPlayPause(item.id, video);
//                           }}
//                         >
//                           {isPlaying[item.id] ? (
//                             <FaPause size={30} />
//                           ) : (
//                             <FaPlay size={30} />
//                           )}
//                         </button>

//                         <button
//                           className={styles.muteButton}
//                           onClick={(e) => {
//                             const video =
//                               e.currentTarget.parentElement.parentElement.querySelector(
//                                 "video"
//                               );
//                             video.muted = !video.muted;
//                             setIsMuted((prev) => ({
//                               ...prev,
//                               [item.id]: !prev[item.id],
//                             }));
//                           }}
//                         >
//                           {isMuted[item.id] ? (
//                             <FaVolumeMute size={20} />
//                           ) : (
//                             <FaVolumeUp size={20} />
//                           )}
//                         </button>

//                         <button
//                           className={`${styles.expandButton} ${
//                             !isPlaying[item.id] ? styles.hideButton : ""
//                           }`}
//                           onClick={(e) => {
//                             const video =
//                               e.currentTarget.parentElement.parentElement.querySelector(
//                                 "video"
//                               );
//                             if (video.requestFullscreen) {
//                               video.requestFullscreen();
//                             }
//                           }}
//                         >
//                           <FaExpand size={20} />
//                         </button>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             ),
//           }))}
//         />
//       </div>
//     </div>
//   );
// };

// export default HomeCommunityCarousel;

import React, { useContext, useRef, useEffect, useState } from "react";
import styles from "./HomeCommunityCarousel.module.css";
// import styles from "./index.css";
import { HomePageContext } from "../../store/HomePageContext";
import { Link } from "react-router-dom";
import { FourElementsCarousel } from "../../utilities";
import {
  FaPlay,
  FaPause,
  FaExpand,
  FaVolumeMute,
  FaVolumeUp,
} from "react-icons/fa";

const HomeCommunityCarousel = ({ itemWidth, itemHeight, items }) => {
  const { homeScreenDetails } = useContext(HomePageContext);
  const maflamShowsData = homeScreenDetails?.maflamShowsData || [];
  const maflamShowsDataTitle = homeScreenDetails?.maflamShowsTitle || [];
  const [isPlaying, setIsPlaying] = useState({});
  const [isMuted, setIsMuted] = useState({});

  // Add this function to handle video play/pause
  const handleVideoPlayPause = (videoId, video) => {
    if (isPlaying[videoId]) {
      video.pause();
      setIsPlaying((prev) => ({ ...prev, [videoId]: false }));
    } else {
      video.play();
      setIsPlaying((prev) => ({ ...prev, [videoId]: true }));
    }
  };

  return (
    <div className={styles.parent}>
      <div className={styles.carouselcontainer}>
        <Link to="R2/R4/socialmedia">{maflamShowsDataTitle.title}</Link>
        <FourElementsCarousel
          style={{ width: "100%", overflow: "hidden" }}
          itemWidth={itemWidth}
          itemHeight={itemHeight}
          items={maflamShowsData.map((item) => ({
            id: item.id,
            content: (
              <div className={styles.card}>
                <img
                  src={item.logoUrl}
                  alt={`Show logo`}
                  className={styles.logo89}
                  style={{ width: itemWidth, height: itemHeight }}
                />
                <div className={styles.videoContainer}>
                  <video
                    src={item.videoUrl}
                    className={styles.img89}
                    muted={isMuted[item.id]}
                    loop
                    playsInline
                    poster={item.thumbNailUrl}
                    style={{ maxWidth: "320px" }}
                    onPlay={() =>
                      setIsPlaying((prev) => ({ ...prev, [item.id]: true }))
                    }
                    onPause={() =>
                      setIsPlaying((prev) => ({ ...prev, [item.id]: false }))
                    }
                  >
                    Your browser does not support the video tag.
                  </video>
                  <div className={styles.videoControls}>
                    <button
                      className={styles.playButton}
                      onClick={(e) => {
                        const video =
                          e.currentTarget.parentElement.parentElement.querySelector(
                            "video"
                          );
                        handleVideoPlayPause(item.id, video);
                      }}
                    >
                      {isPlaying[item.id] ? (
                        <FaPause size={30} />
                      ) : (
                        <FaPlay size={30} />
                      )}
                    </button>

                    <button
                      className={styles.muteButton}
                      onClick={(e) => {
                        const video =
                          e.currentTarget.parentElement.parentElement.querySelector(
                            "video"
                          );
                        video.muted = !video.muted;
                        setIsMuted((prev) => ({
                          ...prev,
                          [item.id]: !prev[item.id],
                        }));
                      }}
                    >
                      {isMuted[item.id] ? (
                        <FaVolumeMute size={20} />
                      ) : (
                        <FaVolumeUp size={20} />
                      )}
                    </button>

                    <button
                      className={`${styles.expandButton} ${
                        !isPlaying[item.id] ? styles.hideButton : ""
                      }`}
                      onClick={(e) => {
                        const video =
                          e.currentTarget.parentElement.parentElement.querySelector(
                            "video"
                          );
                        if (video.requestFullscreen) {
                          video.requestFullscreen();
                        }
                      }}
                    >
                      <FaExpand size={20} />
                    </button>
                  </div>
                </div>
              </div>
            ),
          }))}
        />
      </div>
    </div>
  );
};

export default HomeCommunityCarousel;
